export default __webpack_public_path__ + "static/media/17.4ae8e978.png";